<app-about/>
<app-highlights/>
<app-experience/>
<app-projects/>
<app-contact/>
<app-credit/>
